<div class="container">
    <div class="row justify-content-center">
        <div class="col-sm-8 ">
            <div class="card bg2 text-center">
                <div class="card-body">
                    <h1 class="card-title h1">Lorem ipsum dolor sit amet</h1>
                     <p class="card-subtitle text">Your publish on web Lorem ipsum, dolor sit amet consectetur adipisicing elit. Aperiam commodi quos nemo, velit deleniti in consectetur, expedita sunt totam voluptas itaque alias quo! Ab commodi dolorum saepe.</p>   
                </div>
            </div>
          </div>
    </div>
    <div class="row justify-content-center bg2">
        <div class="">
            <a href="https://github.com/david69-js"><img src="https://fontmeme.com/permalink/201023/42ac45b451e0c8af2302dd59ab1c1e02.png" alt="fuentes-para-firmas" border="0"></a>
        </div>
    </div>
</div>
